// removed by extract-text-webpack-plugin
module.exports = {"updatePassword":"_10SuvGIWFRtTXrF1E1f5e8","title":"_2f-MwDU9lOQXiMD4VxyvDm","authorization_buttons":"_28E6z6RDEqZjvLxCRUi4G","form_link":"_1uysW13gMGPqgwZWcw7X9l","form_linka":"_3mYlOE6VQsF2iL_wYWJleP","content":"_2aNx1a-sQYyqAtTimqMN4y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAuthentication/UpdatePassword/UpdatePassword.scss
// module id = 1809
// module chunks = 0